import React from 'react';
import { PropTypes } from 'prop-types';

import Modal from 'components/layout/Modal';

import Header from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/Header';
import Description from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/Description';
import DiscardForm from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/DiscardForm';

const RecurringOrderSuggestionsDiscardReasonsModal = ({
  className,
  sendRecurringOrderSuggestionDiscardReason,
  t,
}) => (
  <Modal show size="M" closeButton={false} withpadding={false}>
    <div
      className={className}
      data-testid="recurring-order-suggestions-discard-modal"
    >
      <Header t={t} />
      <Description t={t} />
      <DiscardForm
        sendRecurringOrderSuggestionDiscardReason={
          sendRecurringOrderSuggestionDiscardReason
        }
        t={t}
      />
    </div>
  </Modal>
);

RecurringOrderSuggestionsDiscardReasonsModal.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  sendRecurringOrderSuggestionDiscardReason: PropTypes.func,
};

RecurringOrderSuggestionsDiscardReasonsModal.defaultProps = {
  className: '',
  t: (t) => t,
  sendRecurringOrderSuggestionDiscardReason: () => ({}),
};

export default RecurringOrderSuggestionsDiscardReasonsModal;
